import Select, { components } from "react-select";
import {
  mapOptionsWithFoundationDisabled,
  shouldHideFoundationMultiValueRemove,
  withLockedFoundationSelection,
} from "../utils/serviceCategoryBadgeDisplay";

/**
 * react-select multi that always keeps Foundation - All selected and non-removable.
 */
export default function FoundationLockedMultiSelect({
  options,
  value,
  onChange,
  components: userComponents,
  animatedComponents = {},
  ...rest
}) {
  return (
    <Select
      {...rest}
      isMulti
      options={mapOptionsWithFoundationDisabled(options)}
      value={withLockedFoundationSelection(value)}
      onChange={(selected) => {
        onChange?.(withLockedFoundationSelection(selected));
      }}
      components={{
        ...animatedComponents,
        ...userComponents,
        MultiValueRemove: (props) => {
          if (shouldHideFoundationMultiValueRemove(props.data)) {
            return null;
          }
          return <components.MultiValueRemove {...props} />;
        },
      }}
    />
  );
}
